import { render, staticRenderFns } from "./Payoneer.vue?vue&type=template&id=87c1956e&scoped=true&"
import script from "./Payoneer.vue?vue&type=script&lang=js&"
export * from "./Payoneer.vue?vue&type=script&lang=js&"
import style0 from "./Payoneer.vue?vue&type=style&index=0&id=87c1956e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c1956e",
  null
  
)

export default component.exports